import { handleGetRequest } from "./http.service";

export interface EmployerUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  createdAt: string;
}

export interface Employer {
  _id: string;
  user: EmployerUser;
  gender?: string;
  state?: string;
  lga?: string;
  residenceState?: string;
  residenceLga?: string;
  profilePicture?: { url: string };
  docType?: string;
  createdAt: string;
}

export interface EmployersResponse {
  page: number;
  limit: number;
  total: number;
  data: Employer[];
}

export const getAllEmployers = async (params?: {
  page?: number;
  limit?: number;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  const query = qs.toString() ? `?${qs}` : "";
  return handleGetRequest<EmployersResponse>(`/employers${query}`);
};
